module.exports = __webpack_public_path__ + "static/media/triban.5aef4dd7.png";